module.exports = __webpack_public_path__ + "img/131.216c347f.jpg";